// @flow
import { styled } from 'mz-ui-kit'

export const Container = styled<{
  $color?: string,
}>('div', ({ $color, $palette }) => {
  const bgColor = $palette($color).lighten(38)
  const borderColor = $palette($color).lighten(30)
  if (borderColor.isLight) {
    borderColor.darken(20)
  }

  return {
    borderRadius: '3px',
    padding: '10px',
    position: 'relative',
    color: `${borderColor.clone().darken(30)}`,
    border: `1px solid ${borderColor}`,
    backgroundColor: `${bgColor}`,
  }
})
